<template>
  <div class="joint-us">
    <nav-bar :main-index="1"></nav-bar>
    <el-tabs
      :style="[{'height':height}]"
      :tab-position="tabPosition"
      class="myTabs wow fadeInLeft"
      data-wow-duration="1s"
      type="card"
      v-model="activeName"
    >
      <el-tab-pane label="大数据架构师" name="first">
        <p>学历：计算专硕、博士</p>
        <p>职位描述：</p>
        <p>负责公司数据仓库实时、离线架构设计，确保架构设计合理性、扩展性、可用性。负责0-1构建数据团队，实现数据、算法、平台化的技术产品输出，分布式数据系统核心服务和子系统的细节设计和实现，需要时领导跨职能小组解决产品开发过程中的关键问题,为团队提供通用的软件范例和编码实践的指导，并提高设计质量,树立高质量工程设计和最佳实践的关键人物形象。</p>
        <p>岗位要求：</p>
        <p>1、具有数据系统架构师思维（优秀的抽象能力）和优秀的编程能力；</p>
        <p>2、计算机科学或数学相关领域的硕士/博士学位；</p>
        <p>3、10年以上相关工作经验；</p>
        <p>4、深入了解主流开源框架代码，C++、Spring Boot、 Python其中一种全栈能力'；</p>
        <p>5、有搭建并推出多数据产品系统的实战实践经验；</p>
        <p>6、Hadoop、Spark、Hbase、Kafka、Flink、缓存技术，代码级优化能力；</p>
        <p>7、熟悉架构和设计工具，并能改善效率、提升技术专业水平；</p>
        <p>8、良好的沟通技巧，能够在不同层面与不同的人进行有效沟通；</p>
        <p>必要条件：</p>
        <p>1、负责数据仓库模型设计，确保模型设计的高复用性，模型满足业务90%取数需求；</p>
        <p>2、完善的架构方法论和经过规模化实践；</p>
        <p>3、优秀的数据、算法、计算平台、建模、有过完整的数据驱动业务经验；</p>
        <p>4、大数据推荐系统、标签化、Hadoop平台、数仓技术平台经验；</p>
        <p>5、负责数据仓库性能优化与协助团队解决开发遇到的问题；</p>
        <p>6、负责数据仓库核心代码逻辑开发与推进落地；</p>
        <p>7、英语优秀 （至少过6级）；</p>
        <p>8、计算机本科（专业排名TOP 10），国际排名 TOP 30；</p>
        <p>9、百人以上研发团队规模；</p>
        <p>10、最近一份系统级数据架构师工作三年以上；</p>
        <p>11、0-1成功项目经验；</p>
        <p>加分项目：</p>
        <p>1、百亿美金以上的上市或准上市公司背景；</p>
        <p>2、百万级以上的全球用户规模；</p>
        <p>3、熟悉跨境金融及交易系统；</p>
        <p>4、开源项目代码共享者；</p>
        <p>5、系统分析师；</p>
      </el-tab-pane>
      <el-tab-pane label="软件工程师" name="second">
        <p>招聘岗位：C++</p>
        <p>职位描述：</p>
        <p>1、负责期货、股票交易系统的研发；</p>
        <p>2、编写模块、详细设计文档和相关技术资料；</p>
        <p>3、负责对开发内容的单元测试、集成测试；</p>
        <p>4、负责解决开发过程中的技术问题。</p>
        <p>岗位要求：</p>
        <p>1、全日制本科以上学历，软件工程或计算机相关专业；</p>
        <p>2、3-5年C/C++开发经验；</p>
        <p>3、熟练掌握常用数据结构及其算法；</p>
        <p>4、良好的代码风格、积极的工作态度；</p>
        <p>加分项目：</p>
        <p>1、熟悉网络编程，对tcp/ip有深入了解</p>
        <p>2、有Linux平台编程经验</p>
        <br />
        <hr color="#605c57" />
        <br />
        <p>招聘岗位：C#</p>
        <p>职位描述：</p>
        <p>1、负责证券交易系统的业务模块开发与平台运维</p>
        <p>2、参与需求分析，编写开发设计文档，根据具体的模块需求，独立完成新增模块的设计编码工作；</p>
        <p>3、发现和解决现有系统中存在的技术问题，保证系统的性能和稳定性；</p>
        <p>4、负责解决开发过程中的技术问题。</p>
        <p>岗位要求：</p>
        <p>1、全日制本科及以上，计算机相关专业，985、211院校优先；</p>
        <p>2、C#基础扎实，包括IO、多线程、并发、网络，理解面向对象、封装抽象等；</p>
        <p>3、精通C#开发，熟悉Socket，WinForm、WPF、DevExpress界面开发等技术；</p>
        <p>4、精通SQLServer，熟练掌握SQL编写,掌握基本的数据库维护和调优，熟悉数据库设计；</p>
        <p>5、善于学习和与人沟通，为人正直、诚信，有较强的事业心，有较强的分析、解决应用问题的能力；具有团队合作精神；时刻保持对新技术，新编程思想的敏感性，具备持续学习能力并乐于进行技术分享；</p>
        <p>6、具有证券相关行业经验优先；</p>
        <br />
        <hr color="#605c57" />
        <br />
        <p>招聘岗位：iOS</p>
        <p>职位描述：</p>
        <p>1、负责期货，股票行情与交易系统的研发；</p>
        <p>2、编写模块、详细设计文档和相关技术资料；</p>
        <p>3、负责对开发内容的单元测试；</p>
        <p>4、负责解决开发过程中的技术问题；</p>
        <p>岗位要求：</p>
        <p>1、全日制本科及以上，计算机相关专业；</p>
        <p>2、熟练掌握Objective-C，具备架构和设计APP框架能力；</p>
        <p>3、熟练运用UI组件、socket、http、XML/JSON解析、sqlite、多线程等编程技术；</p>
        <p>4、熟悉APPSTORE审核上线流程；</p>
        <p>5、对软件产品有强烈的责任心，具备良好的沟通能力和团队协作能力；</p>
        <p>6、有三年以上iOS开发经验，具有金融类（如期货、证劵、银行类）客户端应用开发者优先；</p>
        <br />
        <hr color="#605c57" />
        <br />
        <p>招聘岗位：Android</p>
        <p>职位描述：</p>
        <p>1、负责移动端项目系统新增业务模块开发与平台运维；</p>
        <p>2、参与需求分析，编写开发设计文档，根据具体的模块需求，独立完成新增模块的设计编码工作；</p>
        <p>3、发现和解决现有系统中存在的技术问题，保证系统的性能和稳定性；</p>
        <p>4、能够在UI设计人员的配合下，开发出高质量的应用程序界面；</p>
        <p>岗位要求：</p>
        <p>1、全日制本科及以上，计算机相关专业；</p>
        <p>2、五年以上Android开发经验，精通Java语言，熟悉Android应用开发框架，能独立开发高可靠的Android应用；</p>
        <p>3、独立负责或作为主要开发者参与过1款以上App的研发，并能够在主要渠道下载安装；</p>
        <p>4、熟悉Android各种widget组件，能根据项目要求开发自定义控件；</p>
        <p>5、熟悉TCP、HTTP等网络协议，以及XML、JSON等数据格式，能够针对移动平台进行网络和性能优化；</p>
        <p>6、善于学习和与人沟通，为人正直、诚信，有较强的事业心，有较强的分析、解决应用问题的能力；具有团队合作精神；时刻保持对新技术，新编程思想的敏感性，具备持续学习能力并乐于进行技术分享；</p>
        <p>7、具有证券相关行业经验优先；</p>
        <br />
        <hr color="#605c57" />
        <br />
        <p>招聘岗位：Java</p>
        <p>职位描述：</p>
        <p>1、负责Java Web项目系统新增业务模块开发与平台运维；</p>
        <p>2、参与需求分析，编写开发设计文档，根据具体的模块需求，独立完成新增模块的设计编码工作；</p>
        <p>3、发现和解决现有系统中存在的技术问题，保证系统的性能和稳定性；</p>
        <p>岗位要求：</p>
        <p>1、全日制本科及以上，计算机相关专业；</p>
        <p>2、JAVA基础扎实，包括JVM、IO、多线程、并发、网络，理解面向对象、单例、工厂，观察者等基本设计模式、封装抽象等；</p>
        <p>3、熟练使用常用的Java Web开源技术框架如SpringBoot、Mybatis等，并有类似项目经验；</p>
        <p>4、熟练使用Html、CSS、Javascript等常用Web前端开发技巧；</p>
        <p>5、熟练使用MYSQL，SQLSERVER关系数据库和REDIS内存数据库，对SQL有较强的优化能力；</p>
        <p>6、善于学习和与人沟通，为人正直、诚信，有较强的事业心，有较强的分析、解决应用问题的能力；具有团队合作精神；时刻保持对新技术，新编程思想的敏感性，具备持续学习能力并乐于进行技术分享；</p>
        <p>7、具有证券相关行业经验优先；</p>
        <br />
        <hr color="#605c57" />
        <br />
        <p>招聘岗位：前端</p>
        <p>职位描述：</p>
        <p>1、负责web项目系统新增业务模块开发与平台运维（包括PC和移动端）；</p>
        <p>2、参与需求分析，编写开发设计文档，根据具体的模块需求，独立完成新增模块的设计编码工作；</p>
        <p>3、发现和解决现有系统中存在的技术问题，保证系统的性能和稳定性；</p>
        <p>能够在UI设计人员的配合下，开发出高质量的应用程序界面；</p>
        <p>岗位要求：</p>
        <p>1、全日制本科及以上，计算机相关专业；</p>
        <p>2、 熟练运用HTML+CSS来制作符合W3C标准的静态页面，兼容各大PC和手机浏览器(IE9+、Chrome、Safari、Firefox、Opera、QQ、微信等)；</p>
        <p>3、熟练掌握XHTML/HTML5/CSS/JavaScript前端技术，具有3年以上相关编程经验；</p>
        <p>4、熟练使用至少一种JS框架（如 jQuery、backbone、angularjs、vue.js、react），并有一定的项目经验；</p>
        <p>5、熟悉Web前端与后端交互数据接口定义，会使用websocket；</p>
        <p>6、熟练运用Echarts、Amcharts 等可视化图表；</p>
        <p>7、具有证券相关行业经验优先；</p>
        <br />
        <hr color="#605c57" />
      </el-tab-pane>
      <el-tab-pane label="软件测试" name="three">
        <p>招聘岗位：软件测试</p>
        <p>职位描述：</p>
        <p>1、负责股票、期货交易等系统的功能、性能和专项测试工作。</p>
        <p>2、编写测试计划、测试思路、测试用例，搭建测试环境，执行测试用例，递交测试报告，包括编写自动化测试脚本、测试方案等相关的技术文档；</p>
        <p>3、对测试过程中发现的问题进行详细分析并协助定位，与开发人员讨论缺陷解决方案；</p>
        <p>4、参与需求分析工作，对需求文档进行静态测试；</p>
        <p>5、定期向上级领导提交测试进度情况报告；</p>
        <p>6、完成上级主管临时交办的其它工作。</p>
        <p>岗位要求：</p>
        <p>1、统招本科及以上学历；</p>
        <p>2、1年以上相关工作经验，必须有手机端专项测试经验；</p>
        <p>3、至少熟悉自动化测试工具(Appium)和性能测试工具（如MonkeyRunner）中任意一种；</p>
        <p>4、有期货或证券类工作经验优先；</p>
        <p>5、有过系统的“专业测试技术培训”者优先；</p>
        <p>6、有较强的责任心，执行力强；有良好的理解与表达能力。</p>
      </el-tab-pane>
      <el-tab-pane label="金融产品经理" name="four">
        <p>学历：金融本科+专硕、博士</p>
        <p>职位描述：</p>
        <p>
          负责公司金融产品的调研、需求、概设与金融产品化体系建设，通过产品去解决行业痛点，不断优化和改善用户体验，提升产品知名度与美誉度，实现从to B to C企业级产品到消费级产品及解决方案全覆盖，为每年的产品目标达成负责。完善产品从行业共性需求到产品化输出的路径。
          需要时领导跨职能小组解决金融产品开发过程中的关键问题,为团队提供通用的金融产品范例和业内最佳实践的指导，并提高设计质量,树立高质量产品设计和最佳实践的关键人物形象。
        </p>
        <p>岗位要求：</p>
        <p>1、国际型跨国银行背景；</p>
        <p>2、具有现象级金融产品构建能力；</p>
        <p>3、满足现有业务需求；</p>
        <p>4、提升用户产品体验；</p>
        <p>5、引领用户，创新、创造新的爆点产品和模式；</p>
        <p>6、相关金融领域的硕士/博士学位；</p>
        <p>7、5年以上相关工作经验；</p>
        <p>8、深入了解主流互联网头部券商、基金、银行金融产品特征、模型、特色及市场调研能力；</p>
        <p>9、有搭建并推出多个成功规模化金融产品实战经验；</p>
        <p>10、优秀的金融产品团队及体系建设能力；</p>
        <p>11、熟悉常用产品设计工具，并能改善团队效率、提升技术专业水平；</p>
        <p>12、良好的沟通技巧，能够在不同层面与不同的人进行有效沟通；</p>
        <p>必要条件：</p>
        <p>1、超强的金融背景，金融产品设计能力、高度的责任心与自驱力；</p>
        <p>2、完善的金融产品方法论和经过规模化实践；</p>
        <p>3、具备熟练的数据分析能力，竞品分析能力，总结归纳能力；</p>
        <p>4、从0-1的金融产品化平台构建经验；</p>
        <p>5、国际化视野，英语优秀 （至少过6级）；</p>
        <p>6、硕士及以上（国内专业排名TOP 10），国际排名 TOP 20；</p>
        <p>7、百人以上研发团队规模；</p>
        <p>8、最近一份金融产品工作三年以上</p>
        <p>加分项目：</p>
        <p>1、百亿美金以上的上市或准上市公司背景；</p>
        <p>2、百万级以上的全球用户规模；</p>
        <p>3、熟悉跨境金融及交易系统，熟悉全球主要投资金融品种；</p>
        <p>4、国际化的教育和国际化的金融视野；</p>
      </el-tab-pane>

      <div class="bottomMask">
        <!-- <img alt="" src="../assets/images/bottomFade.png"> -->
      </div>
    </el-tabs>
    <a :href="mailTo" class="sendMailButton">点击投递</a>
    <p class="mailAddress">hr邮箱: hr@directaccess.cn</p>
    <img alt="招聘，工作" class="hiddenImg" src="../assets/images/joinUsBg.png" />
  </div>
</template>

<script>
import navBar from "../components/navBar";
export default {
  name: "joinUs",
  data() {
    return {
      tabPosition: "left",
      activeName: "first",
      height: window.innerHeight - 118 + "px",
      mailTo: "mailto:hr@directaccess.cn?subject=邮件标题&body=邮件内容"
    };
  },
  beforeMount() {},
  mounted() {
    new this.$wow.WOW().init();
  },
  watch: {},
  methods: {},
  components: {
    navBar: navBar
  }
};
</script>

<style>
.el-tabs__item {
  text-align: center !important;
  color: #fff !important;
  font-family: Lantinghei SC !important;
  font-weight: 600 !important;
  border: none !important;
}

.el-tabs__item:hover {
  color: #ffa63e !important;
}

.el-tabs__nav,
.el-tabs__header {
  border: none !important;
  margin-right: 0 !important;
}

.is-active {
  color: #ffa63e !important;
  background: #1f293b !important;
  opacity: 0.9 !important;
}

.homeContent {
  background-image: url(../assets/images/joinUsBg.png);
  background-repeat: no-repeat;
  background-size: 100%;
}

.el-tabs__content {
  background: rgb(31, 41, 60);
  opacity: 0.9;
}

.el-tab-pane {
  font-family: Lantinghei SC;
  font-weight: 200;
  color: #ffffff;
  overflow-x: hidden;
  overflow-y: auto;
}

.el-tab-pane::-webkit-scrollbar {
  display: none;
}

.sendMailButton {
  display: inline-block;
  background: #b28850;
  font-family: Lantinghei SC;
  font-weight: 600;
  color: #ffffff;
  text-align: center;
  text-decoration: none;
  position: absolute;
}

.mailAddress {
  position: absolute;
}

.bottomMask {
  width: 100%;
  z-index: 99;
  position: absolute;
  bottom: 0;
  background: linear-gradient(
    to top,
    rgba(31, 41, 60, 0.75),
    75%,
    rgba(0, 0, 0, 0)
  );
}

.bottomMask img {
  position: absolute;
  bottom: -200px;
}
</style>



// WEBPACK FOOTER //
// src/components/joinUs.vue